import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { merge, Subscription } from 'rxjs';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';

import Utils from 'src/app/helpers/utils';
import { ApiService } from 'src/app/services/api/api.service';
import { FundService } from 'src/app/services/fund/fund.service';
import { SignupService } from 'src/app/services/signup/signup.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import fakerbr from 'faker-br';
import { MaskPipe } from 'ngx-mask';
import { AuthService } from 'src/app/services/auth/auth.service';
import { distinctUntilChanged } from 'rxjs/operators';
import { StorageService } from 'src/app/services/storage/storage.service';
import { RegistrationRequeueService } from 'src/app/services/registration/registration-requeue.service';

@Component({
  selector: 'app-dashboard-admin-assignors',
  templateUrl: './dashboard-admin-assignors.component.html',
  styleUrls: ['./dashboard-admin-assignors.component.scss'],
})
export class DashboardAdminAssignorsComponent implements OnInit {
  departmentOptions: SelectItem[] = [];
  currentStageDepartmentOptions: SelectItem[] = [];
  expiredOptions: SelectItem[] = [
    { label: 'Expirado', value: 'true' },
    { label: 'Não Expirado', value: 'false' },
  ];
  investorProfileOptions: SelectItem[] = [
    { label: 'Conservador', value: 1 },
    { label: 'Moderado', value: 2 },
    { label: 'Agressivo', value: 3 },
    { label: 'Não declarado', value: 'not_declared' },
  ];
  statusOptions: SelectItem[] = [
    { label: 'Pendentes', value: 'pending' },
    { label: 'Rejeitados', value: 'rejected' },
    { label: 'Aprovados', value: 'approved' },
  ];

  errrorMessageObj: ErrorMessagesObj = {
    created_from: '',
    created_to: '',
    updated_from: '',
    updated_to: '',
  };

  form = this.formBuilder.group({
    name: [null, []],
    agent: [null, []],
    document: [null, [Validators.required, Utils.validateCpfCnpj]],
    due_date: [null, [Validators.required, Utils.validateMinDate]],
    email: [null, [Validators.required, Validators.email]],
    fund: [null, []],
    is_approver: [false, []],
  });

  filterForm = this.formBuilder.group({
    name: [null],
    document: [null, [Utils.validateCpfCnpj]],
    role_filter: [null],
    agents: [null],
    roles: [null],
    current_stage_department: [null],
    expired: [null],
    investor_profile_number: [null],
    created_from: [
      null,
      [
        (control: FormControl) => {
          if (!control.value) {
            return null;
          }

          if (Utils.validateDateValid(control)) {
            this.errrorMessageObj.created_from = 'Data inválida';
            return { date: true };
          }

          control.parent?.controls?.['created_to'].setValidators([
            Validators.required,
            (control: FormControl) => {
              if (Utils.validateDateValid(control)) {
                this.errrorMessageObj.created_to = 'Data inválida';
                return { date: true };
              }

              if (Utils.validateMaxMinToday(control)) {
                this.errrorMessageObj.created_to =
                  'A data não pode ser maior que hoje';
                return { max: true };
              }

              const toValue = control.value.split('/').reverse().join('-');
              const fromValue = control.parent.controls?.['created_from'].value
                ? control.parent.controls?.['created_from'].value
                    .split('/')
                    .reverse()
                    .join('-')
                : null;

              if (fromValue) {
                let fromDate = new Date(fromValue);
                const toDate = new Date(toValue);

                if (fromDate > toDate) {
                  this.errrorMessageObj.created_to =
                    'A data final não pode ser menor que a data inicial';
                  return { min: true };
                }
              }

              return null;
            },
          ]);

          control.parent?.controls?.['created_to'].updateValueAndValidity();

          if (Utils.validateMinDate(control)) {
            this.errrorMessageObj.created_from = 'Data mínima inválida';
            return { min: true };
          }

          if (Utils.validateMaxMinToday(control)) {
            this.errrorMessageObj.created_from =
              'A data não pode ser maior que hoje';
            return { max: true };
          }

          return null;
        },
      ],
    ],

    created_to: [
      null,
      [
        (control: FormControl) => {
          if (!control.value) {
            return null;
          }

          if (Utils.validateDateValid(control)) {
            this.errrorMessageObj.created_to = 'Data inválida';
            return { date: true };
          }

          if (Utils.validateMaxMinToday(control)) {
            this.errrorMessageObj.created_to =
              'A data não pode ser maior que hoje';
            return { max: true };
          }

          const toValue = control.value.split('/').reverse().join('-');
          const fromValue = control.parent.controls?.['created_from'].value
            ? control.parent.controls?.['created_from'].value
                .split('/')
                .reverse()
                .join('-')
            : null;

          if (fromValue) {
            let fromDate = new Date(fromValue);
            const toDate = new Date(toValue);

            if (fromDate > toDate) {
              this.errrorMessageObj.created_to =
                'A data final não pode ser menor que a data inicial';
              return { min: true };
            }
          }

          return null;
        },
      ],
    ],
    updated_from: [
      null,
      [
        (control: FormControl) => {
          if (!control.value) {
            return null;
          }

          if (Utils.validateDateValid(control)) {
            this.errrorMessageObj.updated_from = 'Data inválida';
            return { date: true };
          }

          control.parent?.controls?.['updated_to'].setValidators([
            Validators.required,
            (control: FormControl) => {
              if (Utils.validateDateValid(control)) {
                this.errrorMessageObj.updated_to = 'Data inválida';
                return { date: true };
              }

              if (Utils.validateMaxMinToday(control)) {
                this.errrorMessageObj.updated_to =
                  'A data não pode ser maior que hoje';
                return { max: true };
              }

              const toValue = control.value.split('/').reverse().join('-');
              const fromValue = control.parent.controls?.['updated_from'].value
                ? control.parent.controls?.['updated_from'].value
                    .split('/')
                    .reverse()
                    .join('-')
                : null;

              if (fromValue) {
                let fromDate = new Date(fromValue);
                const toDate = new Date(toValue);

                if (fromDate > toDate) {
                  this.errrorMessageObj.updated_to =
                    'A data final não pode ser menor que a data inicial';
                  return { min: true };
                }
              }

              return null;
            },
          ]);

          control.parent?.controls?.['updated_to'].updateValueAndValidity();

          if (Utils.validateMinDate(control)) {
            this.errrorMessageObj.updated_from = 'Data mínima inválida';
            return { min: true };
          }

          if (Utils.validateMaxMinToday(control)) {
            this.errrorMessageObj.updated_from =
              'A data não pode ser maior que hoje';
            return { max: true };
          }

          return null;
        },
      ],
    ],
    updated_to: [
      null,
      [
        (control: FormControl) => {
          if (!control.value) {
            return null;
          }

          if (Utils.validateDateValid(control)) {
            this.errrorMessageObj.updated_to = 'Data inválida';
            return { date: true };
          }

          if (Utils.validateMaxMinToday(control)) {
            this.errrorMessageObj.updated_to =
              'A data não pode ser maior que hoje';
            return { max: true };
          }

          const toValue = control.value.split('/').reverse().join('-');
          const fromValue = control.parent.controls?.['updated_from'].value
            ? control.parent.controls?.['updated_from'].value
                .split('/')
                .reverse()
                .join('-')
            : null;

          if (fromValue) {
            let fromDate = new Date(fromValue);
            const toDate = new Date(toValue);

            if (fromDate > toDate) {
              this.errrorMessageObj.updated_to =
                'A data final não pode ser menor que a data inicial';
              return { min: true };
            }
          }

          return null;
        },
      ],
    ],
    profileConservador: [false],
    profileModerado: [false],
    profileAgressivo: [false],
    profileNaoDeclarado: [false],
    profileIsento: [false],
    profileNaoAplicavel: [false],
    statusEmAprovacao: [false],
    statusHomologado: [false],
    estadoCadastroTodos: [true],
    estadoCadastroAtivo: [false],
    estadoCadastroInativo: [false],
    estadoTodos: [true],
    estadoAtivo: [false],
    estadoInativo: [false],
    has_imported: [null],
  });

  results_per_page = 10;
  count = 0;
  offset = 0;
  showing_to = 0;

  users: any[] = [];

  /** Cache por cadastro: evita *ngFor recriar linhas de papéis a cada CD (produção). */
  private roleControlsListCache = new Map<string, any[]>();

  agentOptions: SelectItem[] = [{ label: 'Todos', value: null }];

  roleOptions: SelectItem[] = [{ label: 'Todos', value: null }];

  roleFilterOptions: SelectItem[] = Utils.getRoleFilterOptions();

  loading = true;
  loadingSummary = true;
  loadingTable = true;
  canViewUsers = false;
  canInvite = false;
  exporting = false;

  activeTab: 'all' | 'new' | 'update' = 'all';

  // Armazenar filtros separados por aba
  tabFilters: {
    all: any;
    new: any;
    update: any;
  } = {
    all: null,
    new: null,
    update: null,
  };

  // Controle de requisições para evitar race conditions
  private requestCounter: number = 0;

  fundOptions: SelectItem[] = [];

  newInvite = false;

  showOptions = false;

  role = '';

  selectedRole: string | null = null;
  showFilterModal = false;

  expandedRows = new Set<string>();
  showPaperStatusModal = false;
  paperStatusSubmitting = false;
  paperStatusReasonForm = this.formBuilder.group({
    reason: [null, [Validators.required]],
  });
  registerStatusReasonForm = this.formBuilder.group({
    reason: [null, [Validators.required]],
  });
  selectedPaperItem: any = null;
  selectedPaperRole: any = null;

  showRegisterStatusModal = false;
  registerStatusSubmitting = false;
  /** Espelha `isRegisterActivationConfirmDisabled()` para o modal (atualiza em valueChanges). */
  registerStatusConfirmDisabled = true;
  private registerStatusModalFormSub?: Subscription;
  selectedRegisterItem: any = null;
  registerActivatePaperSelectItems: SelectItem[] = [];
  registerActivatePapersForm = this.formBuilder.group({
    paperId: [null as string | null],
  });

  /**
   * Padrão de Filtros:
   * - hasFilters só deve ser true APÓS aplicar os filtros (método filterUsers())
   * - NÃO atualizar hasFilters no valueChanges do filterForm
   * - hasFilters deve ser atualizado apenas quando:
   *   1. filterUsers() executar com sucesso (após a requisição)
   *   2. resetForm() for chamado (define como false)
   *   3. toggleFilterModal() quando há filtros salvos no storage
   *
   * Isso garante que o botão "Limpar filtros" só apareça após os filtros serem realmente aplicados,
   * não apenas quando o usuário está digitando no formulário.
   */
  hasFilters = false;
  appliedFilters: Array<{ label: string; value: string }> = [];

  today = Utils.todayString();
  is_approver: boolean = false;
  isMaster: boolean = false;
  pages = [];
  _page = 1;
  filters: any;

  set page(value: number) {
    this._page = value;
    this.getUsers();
  }

  get page() {
    return this._page;
  }

  // Getter para verificar se deve mostrar o conteúdo (approver ou colaborador comum)
  get shouldShowContent(): boolean {
    return this.is_approver || this.authService.isCommonCollaborator();
  }

  names: { [Key: string]: string } = {
    ALL: 'Todos',
    ADM: 'Administração',
    ASSIGNOR: 'Cedente',
    SHAREHOLDER: 'Cotista',
    PROVIDER: 'Prestador de serviço',
    GUARANTOR: 'Avalista',
    REPRESENTATIVE: 'Representante',
  };

  statistics = {
    assignor: 0,
    shareholder: 0,
    provider: 0,
    active: 0,
    inactive: 0,
    total: 0,
  };
  userArea: string = '';

  /**
   * Cards de sumário a partir do `summary` no GET my-area-dashboard (mesmo padrão do response da API).
   */
  private applySummaryFromMyAreaDashboardResponse(response: any): void {
    const summary = response?.summary;
    if (!summary || typeof summary !== 'object') {
      return;
    }
    this.statistics = {
      assignor:
        summary.cedentes ??
        summary.assignor ??
        summary.by_role?.assignor ??
        0,
      shareholder:
        summary.cotistas ??
        summary.shareholder ??
        summary.by_role?.shareholder ??
        0,
      provider:
        summary.prestadores ??
        summary.provider ??
        summary.by_role?.provider ??
        0,
      active: summary.ativos ?? summary.active ?? 0,
      inactive: summary.inativos ?? summary.inactive ?? 0,
      total: summary.total ?? summary.total_items ?? 0,
    };
  }

  /** Subtítulo "Meu departamento …" a partir do mesmo GET my-area-dashboard (sem endpoint /summary/). */
  private applyUserAreaFromMyAreaDashboardResponse(response: any): void {
    const raw =
      response?.area ??
      response?.summary?.area ??
      response?.user_area ??
      response?.department_area ??
      '';
    if (typeof raw !== 'string' || !raw.trim()) {
      return;
    }
    this.userArea = raw.includes('Todos (Usuário Master)')
      ? raw.replace(
          'Todos (Usuário Master)',
          'Acesso a todos (Usuário Master)',
        )
      : raw;
  }

  paginate = {
    current_page: 0,
    max_pages: 0,
    per_page: 0,
    total: 0,
    viewing: 0,
  };

  showExportOptions = false;

  permissionObj = {
    canChange: false,
  };

  constructor(
    private api: ApiService,
    private toast: ToastService,
    private router: Router,
    private formBuilder: FormBuilder,
    private fundsService: FundService,
    public signupService: SignupService,
    private authService: AuthService,
    private maskPipe: MaskPipe,
    private storageService: StorageService,
    private http: HttpClient,
    private registrationRequeue: RegistrationRequeueService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.authService.menuLoadedEvent.subscribe(() => {
      // Se for master ou colaborador comum, não precisa verificar permissão
      if (
        !this.authService.isMasterUser() &&
        !this.authService.isCommonCollaborator() &&
        !this.authService.verifyPermission(['de_can_view_my_area'])
      ) {
        this.redirectToFirstMenuItem();
      }
    });

    this.setPermissions();

    // Verificar se é master (type_permission === 'master' || type_permission === 'owner')
    this.isMaster =
      this.authService.user?.type_permission === 'master' ||
      this.authService.user?.type_permission === 'owner';

    if (this.authService.user.active_register) {
      const rolesToApprove = ['assignor', 'provider', 'shareholder', 'fund'];
      const hasApprovePermission = rolesToApprove.some((role) => {
        return this.authService.verifyPermission(`de_can_approve_${role}`);
      });

      this.is_approver =
        this.authService.user.is_superuser || hasApprovePermission;
      this.role =
        this.authService.user.active_register.register.role.applicable;
    }

    this.getData();
    this.getCurrentStageDepartments();

    this.canViewUsers = this.authService.verifyPermission(
      'de_can_view_register',
    );
    this.canInvite = this.authService.verifyPermission('de_can_add_invite');

    // Totais dos cards vêm só do `summary` no GET my-area-dashboard (sem sobrescrever via PendingApprovalService).

    this.form.controls.document.valueChanges
      .pipe(distinctUntilChanged((a: any, b: any) => a === b))
      .subscribe((values) => {
        if (values) {
          this.form.controls.document.setValidators([Utils.validateCpfCnpj]);
        } else {
          this.form.controls.document.setValidators([]);
        }

        this.form.controls.document.updateValueAndValidity();
      });

    // Removido: hasFilters não deve ser atualizado ao digitar no formulário
    // hasFilters só deve ser true após aplicar os filtros (filterUsers())
    // this.filterForm.valueChanges.subscribe((values) => {
    //   const filters = {};
    //   Object.entries(values).forEach(([key, value]: any) => {
    //     if (value !== null && value !== '') {
    //       filters[key] = value;
    //     }
    //   });
    //   this.hasFilters = Object.keys(filters).length > 0;
    // });
  }

  async setAgents() {
    try {
      const res = await this.api.get({
        route: 'api/registration/agent/',
        token: true,
      });

      this.agentOptions = res.map((item: any) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
    } catch (error) {
      console.warn(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    }
  }

  async resetForm() {
    this.loading = true;
    this.loadingTable = true;
    this.loadingSummary = true;
    this.appliedFilters = [];

    // Limpar apenas os campos do formulário, mantendo a aba ativa
    this.filterForm.reset();
    this.filterForm.controls.updated_from.setValidators([]);
    this.filterForm.controls.updated_to.setValidators([]);
    this.filterForm.controls.created_from.setValidators([]);
    this.filterForm.controls.created_to.setValidators([]);

    this.filterForm.controls.updated_from.updateValueAndValidity();
    this.filterForm.controls.updated_to.updateValueAndValidity();
    this.filterForm.controls.created_from.updateValueAndValidity();
    this.filterForm.controls.created_to.updateValueAndValidity();

    // Limpar os filtros da aba atual
    this.tabFilters[this.activeTab] = null;

    // hasFilters deve ser false após limpar
    this.hasFilters = false;

    await this.getUsers();
    this.loading = false;
    this.loadingSummary = false;
  }

  async getRoles() {
    try {
      const res = await this.api.get({
        route: 'api/roles',
        token: true,
      });

      const newAgentsOptions = res.map((_agent: any) => {
        const roles = _agent.slug.split('-');

        if (roles[0].includes('ADM') || roles[0].includes('REPRESENTATIVE')) {
          return undefined;
        }
        return {
          label: `${this.names[roles[0]]} ${_agent.name}`,
          value: _agent.id,
          extra: roles.includes('PJ') ? 'PJ' : 'PF',
        };
      });

      this.roleOptions = newAgentsOptions.filter(
        (agent: any) => agent !== undefined,
      );
    } catch (error) {
      console.warn(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    }
  }

  // Método auxiliar para construir os filtros a partir do formulário
  buildFilters(): any {
    const values = this.filterForm.value;
    const filters: any = {};
    const checkboxKeys = [
      'profileConservador',
      'profileModerado',
      'profileAgressivo',
      'profileNaoDeclarado',
      'profileIsento',
      'profileNaoAplicavel',
      'statusEmAprovacao',
      'statusHomologado',
      'estadoCadastroTodos',
      'estadoCadastroAtivo',
      'estadoCadastroInativo',
      'estadoTodos',
      'estadoAtivo',
      'estadoInativo',
    ];

    Object.entries(values).forEach(([key, value]: any) => {
      if (checkboxKeys.includes(key)) return;
      if (value !== null && value !== '' && value !== false) {
        if (key === 'investor_profile_number') {
          return;
        }
        let newValue = value;
        if (
          key === 'created_from' ||
          key === 'created_to' ||
          key === 'updated_from' ||
          key === 'updated_to'
        ) {
          const formatted = this.filterDateValueToApiFormat(value);
          if (formatted !== undefined) {
            newValue = formatted;
          }
        } else if (key === 'document') {
          newValue = value.replace(/[^\d]/g, '');
        } else if (key === 'current_stage_department') {
          newValue = value;
        } else if (key === 'expired') {
          newValue = value === 'true' || value === true;
        } else if (key === 'has_imported') {
          if (value === true || value === 'true') {
            filters['has_imported'] = true;
          }
          return;
        }
        if (key !== 'has_imported') {
          filters[key] = newValue;
        }
      }
    });

    if (filters['created_from'] && !filters['created_to']) {
      filters['created_to'] = new Date().toISOString().split('T')[0];
    }
    if (filters['created_to'] && !filters['created_from']) {
      filters['created_from'] = '2000-01-01';
    }
    if (filters['updated_from'] && !filters['updated_to']) {
      filters['updated_to'] = new Date().toISOString().split('T')[0];
    }
    if (filters['updated_to'] && !filters['updated_from']) {
      filters['updated_from'] = '2000-01-01';
    }

    const roleStatuses: string[] = [];
    if (values.statusEmAprovacao) roleStatuses.push('pending');
    if (values.statusHomologado) roleStatuses.push('homologated');
    if (roleStatuses.length) filters['role_status'] = roleStatuses;

    const investorProfileNumbers: number[] = [];
    if (values.profileConservador) investorProfileNumbers.push(1);
    if (values.profileModerado) investorProfileNumbers.push(2);
    if (values.profileAgressivo) investorProfileNumbers.push(3);
    if (investorProfileNumbers.length) {
      filters['investor_profile_number'] = investorProfileNumbers.join(',');
    }
    const legacyProfile = values.investor_profile_number;
    if (
      !investorProfileNumbers.length &&
      legacyProfile != null &&
      legacyProfile !== '' &&
      legacyProfile !== 'not_declared'
    ) {
      const n = Number(legacyProfile);
      if (n === 1 || n === 2 || n === 3) {
        filters['investor_profile_number'] = String(n);
      }
    }
    if (values.profileNaoDeclarado || legacyProfile === 'not_declared') {
      filters['not_declared'] = true;
    }
    if (values.profileIsento) filters['is_exempt'] = true;
    if (values.profileNaoAplicavel) filters['not_applicable'] = true;

    if (values.estadoCadastroAtivo) filters['register_active'] = true;
    else if (values.estadoCadastroInativo) {
      filters['register_active'] = false;
    }
    if (values.estadoAtivo) filters['papers_active'] = true;
    else if (values.estadoInativo) filters['papers_active'] = false;

    const versionParam = this.getVersionParam();
    if (versionParam) filters['version'] = versionParam;

    return filters;
  }

  getVersionParam(): string | number | null {
    if (this.activeTab === 'new') {
      return 1; // Retornar como número, não string
    } else if (this.activeTab === 'update') {
      return 'other';
    }
    // Se for 'all', não adiciona o parâmetro
    return null;
  }

  async onTabChange(tab: 'all' | 'new' | 'update') {
    // Limpar os filtros da aba atual antes de mudar (não salvar)
    this.tabFilters[this.activeTab] = null;

    // Limpar o formulário antes de mudar de aba
    this.filterForm.reset();
    this.filterForm.controls.updated_from.setValidators([]);
    this.filterForm.controls.updated_to.setValidators([]);
    this.filterForm.controls.created_from.setValidators([]);
    this.filterForm.controls.created_to.setValidators([]);

    this.filterForm.controls.updated_from.updateValueAndValidity();
    this.filterForm.controls.updated_to.updateValueAndValidity();
    this.filterForm.controls.created_from.updateValueAndValidity();
    this.filterForm.controls.created_to.updateValueAndValidity();

    // Limpar estado de filtros
    this.hasFilters = false;
    this.appliedFilters = [];

    // Ativar loading imediatamente
    this.loadingTable = true;
    this.loading = true;

    // Incrementar contador de requisições
    this.requestCounter++;
    const currentRequestId = this.requestCounter;

    // Mudar para a nova aba
    this.activeTab = tab;

    // Carregar os filtros da nova aba (se existirem)
    this.loadTabFilters(tab);

    // Recarregar dados quando trocar de aba
    await this.getUsers(1, currentRequestId);
    this.loadingSummary = false;
  }

  // Carregar os filtros da aba especificada
  loadTabFilters(tab: 'all' | 'new' | 'update') {
    const savedFilters = this.tabFilters[tab];

    if (savedFilters) {
      // Preparar o documento formatado
      let documentFormatted = null;
      if (savedFilters.document) {
        const docLength = savedFilters.document.length;
        documentFormatted = Utils.formatDocumentForDisplay(savedFilters.document);
      }

      // Converter expired de boolean para string se existir
      let expiredValue = savedFilters.expired;
      if (expiredValue !== undefined && expiredValue !== null) {
        expiredValue =
          expiredValue === true || expiredValue === 'true' ? 'true' : 'false';
      }

      const investorProfileValue = savedFilters.investor_profile_number;
      const {
        role_status,
        investor_profile,
        registration_state,
        role_state,
        not_declared,
        is_exempt,
        not_applicable,
        register_active,
        papers_active,
        ...rest
      } = savedFilters;

      const roleStatuses = Array.isArray(role_status) ? role_status : [];

      let estadoCadastroTodos: boolean;
      let estadoCadastroAtivo: boolean;
      let estadoCadastroInativo: boolean;
      if (register_active === true || register_active === false) {
        estadoCadastroTodos =
          register_active !== true && register_active !== false;
        estadoCadastroAtivo = register_active === true;
        estadoCadastroInativo = register_active === false;
      } else {
        estadoCadastroTodos = !(
          Array.isArray(registration_state) && registration_state.length > 0
        );
        estadoCadastroAtivo =
          Array.isArray(registration_state) &&
          registration_state.includes('active');
        estadoCadastroInativo =
          Array.isArray(registration_state) &&
          registration_state.includes('inactive');
      }

      let estadoTodos: boolean;
      let estadoAtivo: boolean;
      let estadoInativo: boolean;
      if (papers_active === true || papers_active === false) {
        estadoTodos = papers_active !== true && papers_active !== false;
        estadoAtivo = papers_active === true;
        estadoInativo = papers_active === false;
      } else {
        estadoTodos = !(Array.isArray(role_state) && role_state.length > 0);
        estadoAtivo =
          Array.isArray(role_state) && role_state.includes('active');
        estadoInativo =
          Array.isArray(role_state) && role_state.includes('inactive');
      }

      const profileNumbers =
        this.parseInvestorProfileNumbersFromFilter(investorProfileValue);
      const profiles = Array.isArray(investor_profile) ? investor_profile : [];

      this.filterForm.patchValue({
        ...rest,
        created_from: savedFilters.created_from
          ? savedFilters.created_from.split('-').reverse().join('/')
          : null,
        created_to: savedFilters.created_to
          ? savedFilters.created_to.split('-').reverse().join('/')
          : null,
        updated_from: savedFilters.updated_from
          ? savedFilters.updated_from.split('-').reverse().join('/')
          : null,
        updated_to: savedFilters.updated_to
          ? savedFilters.updated_to.split('-').reverse().join('/')
          : null,
        document: documentFormatted,
        expired: expiredValue,
        investor_profile_number:
          investorProfileValue === 'not_declared' || not_declared === true
            ? null
            : investorProfileValue,
        statusEmAprovacao: roleStatuses.includes('pending'),
        statusHomologado: roleStatuses.includes('homologated'),
        profileConservador:
          profileNumbers.includes(1) || profiles.includes('conservative'),
        profileModerado:
          profileNumbers.includes(2) || profiles.includes('moderate'),
        profileAgressivo:
          profileNumbers.includes(3) || profiles.includes('aggressive'),
        profileNaoDeclarado:
          not_declared === true ||
          investorProfileValue === 'not_declared' ||
          profiles.includes('not_declared'),
        profileIsento: is_exempt === true,
        profileNaoAplicavel:
          not_applicable === true || profiles.includes('not_applicable'),
        estadoCadastroTodos,
        estadoCadastroAtivo,
        estadoCadastroInativo,
        estadoTodos,
        estadoAtivo,
        estadoInativo,
      });

      // Atualizar estado de filtros
      this.hasFilters = true;
      this.generateFilterTags(this.filterForm.value);
    } else {
      // Se não há filtros salvos, garantir que está limpo
      this.hasFilters = false;
      this.appliedFilters = [];
    }
  }

  async filterUsers() {
    this.roleControlsListCache.clear();
    this.loading = true;
    this.loadingTable = true;
    try {
      const values = this.filterForm.value;
      const filters = this.buildFilters();

      const response = await this.api.get<{
        total_items: number;
        total_pages: number;
        results_per_page: number;
        current_page: number;
        next: string | null;
        previous: string | null;
        results: any[];
        limit: number;
        offset: number;
        showing_to?: number;
        area?: string;
        summary?: {
          total?: number;
          cedentes?: number;
          cotistas?: number;
          prestadores?: number;
          ativos?: number;
          inativos?: number;
          area?: string;
        };
      }>({
        route: 'api/approvals/v3/user_approval/my-area-dashboard/',
        token: true,
        params: {
          ...filters,
          page: 1,
        },
      });

      this.loadingSummary = false;

      const {
        results,
        results_per_page,
        total_items,
        current_page,
        next,
        previous,
        limit,
        offset,
        showing_to,
      } = response;

      this.applySummaryFromMyAreaDashboardResponse(response);
      this.applyUserAreaFromMyAreaDashboardResponse(response);

      this.count = total_items;
      this.results_per_page = results_per_page;
      this.offset = offset;
      this.showing_to = showing_to || offset;

      this.users = results;

      // hasFilters só é atualizado após aplicar os filtros com sucesso
      this.hasFilters = Object.keys(filters).length > 0;

      // Salvar os filtros na aba atual
      if (this.hasFilters) {
        // Remover o parâmetro 'version' dos filtros antes de salvar (ele é específico da aba)
        const filtersToSave = { ...filters };
        delete filtersToSave.version;
        // Salvar expired como string do formulário ao invés do boolean convertido
        if (
          values.expired !== null &&
          values.expired !== undefined &&
          values.expired !== ''
        ) {
          filtersToSave.expired = values.expired;
        }
        this.tabFilters[this.activeTab] = filtersToSave;
      } else {
        this.tabFilters[this.activeTab] = null;
      }

      // Gera as tags dos filtros aplicados
      this.generateFilterTags(values);

      this.loading = false;
    } catch (error) {
      console.error(error);
      this.toast.show(
        'error',
        'Erro',
        'Ocorreu um erro ao carregar os dados de usuários.',
      );
      // Em caso de erro, não atualiza hasFilters
      this.loading = false;
    } finally {
      this.loadingTable = false;
    }
  }

  setFunds() {
    this.fundsService.onChange.subscribe(() => {
      this.fundOptions = this.fundsService.fundList;
    });
  }

  closeModal() {
    this.selectedRole = null;
    this.newInvite = false;
    this.showFilterModal = false;
    this.form.reset();
  }

  async sendInvite() {
    try {
      /* const { exists: emailExists } = await this.api.post({
        route: `validate-email-exists/`,
        body: { email: this.form.value.email },
      });

      if (emailExists) {
        this.toast.show(
          'error',
          'Erro',
          'Já existe um usuário com esse e-mail, não é necessário enviar um convite.'
        );
        return;
      }

      if (this.form.value.document) {
        const { exists: documentExists } = await this.api.post({
          route: `validate-document-exists/`,
          body: { document: this.form.value.document },
        });

        if (documentExists) {
          this.toast.show(
            'error',
            'Erro',
            'Já existe um usuário com esse documento, não é necessário enviar um convite.'
          );
          return;
        }
      } */

      await this.api.post({
        route: 'api/registration/invite/',
        token: true,
        body: {
          data: {
            ...this.form.value,
            register: this.authService.user.active_register.register.id,
          },
          type: this.selectedRole,
        },
      });

      this.toast.show(
        'info',
        'Sucesso',
        `${this.formatName(this.selectedRole)} convidado com sucesso`,
      );
      this.closeModal();
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao enviar o convite');
    }
  }

  getDisabled() {
    return this.form.invalid;
  }

  async getData() {
    this.loading = true;
    this.loadingSummary = true;
    this.loadingTable = true;
    let requests = [this.getDepartments()];

    // Carregar os filtros da aba atual (se existirem)
    this.loadTabFilters(this.activeTab);

    // Se houver filtros carregados, aplicar; caso contrário, apenas buscar usuários
    if (this.hasFilters) {
      requests.push(this.filterUsers());
    } else {
      requests.push(this.getUsers());
    }

    await Promise.all(requests);
    this.loading = false;
    this.loadingSummary = false;
    this.setData();
    this.setFunds();
    this.setAgents();
    this.getRoles();
  }

  toggleShowOptions() {
    this.showOptions = !this.showOptions;
  }

  async getUsers(page: number = 1, requestId?: number) {
    // Se não foi passado requestId, usar o contador atual (para compatibilidade com outras chamadas)
    const currentRequestId = requestId || ++this.requestCounter;

    this.roleControlsListCache.clear();

    this.loadingTable = true;
    try {
      const filters = this.buildFilters();

      const response = await this.api.get<{
        total_items: number;
        total_pages: number;
        results_per_page: number;
        current_page: number;
        next: string | null;
        previous: string | null;
        results: any[];
        limit: number;
        offset: number;
        showing_to?: number;
        area?: string;
        summary?: {
          total?: number;
          cedentes?: number;
          cotistas?: number;
          prestadores?: number;
          ativos?: number;
          inativos?: number;
          area?: string;
        };
      }>({
        route: 'api/approvals/v3/user_approval/my-area-dashboard/',
        token: true,
        params: {
          ...filters,
          page: page,
        },
      });

      // Verificar se esta é a última requisição antes de atualizar os dados
      if (currentRequestId !== this.requestCounter) {
        // Esta requisição não é a mais recente, ignorar resultado
        return;
      }

      const {
        results,
        results_per_page,
        total_items,
        current_page,
        next,
        previous,
        limit,
        offset,
        showing_to,
      } = response;

      this.applySummaryFromMyAreaDashboardResponse(response);
      this.applyUserAreaFromMyAreaDashboardResponse(response);

      this.count = total_items;
      this.results_per_page = results_per_page;
      this.offset = offset;
      this.showing_to = showing_to || offset;

      this.users = results;
      this.loading = false;
    } catch (error) {
      console.error(error);
      // Se esta não for a última requisição, não fazer nada
      if (currentRequestId !== this.requestCounter) {
        return;
      }
      this.toast.show(
        'error',
        'Erro',
        'Ocorreu um erro ao carregar os dados de usuários.',
      );
      this.loading = false;
    } finally {
      // Só desativar loading se esta for a última requisição
      if (currentRequestId === this.requestCounter) {
        this.loadingTable = false;
      }
    }
  }

  toggleFilterModal() {
    this.showFilterModal = !this.showFilterModal;
    if (this.showFilterModal) {
      this.loadTabFilters(this.activeTab);
    }
  }

  getInitials(item: any) {
    // Nova API v3 retorna company_initials diretamente
    if (item.company_initials) {
      return item.company_initials;
    }

    // Fallback para estrutura antiga
    let name = '';
    if (item.register) {
      if (item.register.type.toUpperCase() === 'PF') {
        name = item.register.person.full_name;
      }

      if (item.register.type.toUpperCase() === 'PJ') {
        name = item.register.company.corporate_name;
      }
    }

    if (item.fund) {
      name = item.fund.fantasy_name;
    }

    return Utils.getInitials(name);
  }

  getDisplayName(item: any) {
    // Nova API v3 retorna company_name diretamente
    if (item.company_name) {
      return item.company_name;
    }

    // Fallback para estrutura antiga
    if (item.register) {
      if (item.register.type.toUpperCase() === 'PF') {
        return item.register.person.full_name;
      }

      if (item.register.type.toUpperCase() === 'PJ') {
        return item.register.company.corporate_name;
      }
    }

    if (item.fund) {
      return item.fund.fantasy_name;
    }

    return '';
  }

  getStatus(item: any) {
    // Nova API v3 retorna current_stage_title diretamente
    if (item.current_stage_title) {
      if (item.completed && !item.is_approved) {
        return 'Cadastro rejeitado';
      }
      return item.current_stage_title;
    }

    // Fallback para estrutura antiga
    if (item.completed) {
      if (item.is_approved) {
        return 'Aprovado internamente';
      } else {
        return `${item ? 'Cadastro' : 'Fundo'} rejeitado`;
      }
    } else {
      if (item.current_department !== null) {
        return item.current_department.type === 'department'
          ? item.current_department.department.name
          : item.current_department.agent.name;
      } else if (item.step === 0) {
        return 'Edição';
      } else {
        return 'Departamento não definido';
      }
    }
  }

  getStatusInfo(item: any) {
    // Nova API v3 retorna current_stage_description diretamente
    if (item.current_stage_description) {
      return item.current_stage_description;
    }

    // Fallback para estrutura antiga
    if (item.completed) {
      if (item.is_approved) {
        return 'Integração ao fundo';
      } else {
        if (item.current_department !== null) {
          return item.current_department.type === 'department'
            ? item.current_department.department.name
            : item.current_department.agent.name;
        } else if (item.step === 0) {
          return 'Edição';
        } else {
          return 'Departamento não definido';
        }
      }
    } else if (item.step === 0) {
      return 'Aguardando representantes';
    } else {
      if (!item.queue) return '';
      return `Aguardando aprovação (${item.step}/${item.queue.departments.length})`;
    }
  }

  formatName(name: string) {
    switch (name) {
      case 'assignor':
        return 'Cedente';
      case 'shareholder':
        return 'Cotista';
      case 'provider':
        return 'Prestador de serviço';

      default:
        return 'Cedente';
    }
  }

  formatItemName(item: any) {
    // Prioridade 1: Verificar se existe o array roles
    if (item.roles && Array.isArray(item.roles) && item.roles.length > 0) {
      let rolesToDisplay = item.roles.filter(
        (role: any) => role && role.applicable_display,
      );

      // Se tiver múltiplos papéis e um deles for representante, remove o representante
      // Exceção: se só tiver representante, exibe ele
      if (rolesToDisplay.length > 1) {
        rolesToDisplay = rolesToDisplay.filter(
          (role: any) => role.applicable !== 'representative',
        );
      }

      // Se por acaso o filtro removeu tudo, volta ao original (fallback de segurança)
      if (rolesToDisplay.length === 0 && item.roles.length > 0) {
        rolesToDisplay = item.roles.filter(
          (role: any) => role && role.applicable_display,
        );
      }

      const roleNames = rolesToDisplay.map(
        (role: any) => role.applicable_display,
      );

      if (roleNames.length > 0) {
        return roleNames.join(', ');
      }
    }

    // Prioridade 2: Usar role_name como fallback
    if (item.role_name) {
      if (
        item.role_name === 'Prestador de Serviço' ||
        item.role_name === 'Prestador de serviço'
      ) {
        return 'Prestador de Serviço';
      }
      return item.role_name;
    }

    // Fallback para estrutura antiga
    if (item.register) {
      const name = item.register.role.applicable.toUpperCase();

      switch (name) {
        case 'ASSIGNOR':
          return 'Cedente';
        case 'SHAREHOLDER':
          return 'Cotista';
        case 'PROVIDER':
          // Sempre retornar "Prestador de Serviço" ao invés de mostrar os agents
          return 'Prestador de Serviço';

        default:
          return 'Cedente';
      }
    }

    if (item.fund) {
      return 'Fundo';
    }

    return 'Não identificado';
  }

  getRoleSubtitle(item: any): string {
    // Se for prestador de serviço, mostrar "Pessoa Física" ou "Pessoa Jurídica"
    const roleName = item.role_name || item.register?.role?.applicable;
    if (
      roleName === 'Prestador de Serviço' ||
      roleName === 'Prestador de serviço' ||
      roleName === 'provider'
    ) {
      // Verificar o tipo do registro
      const type = item.type || item.register?.type;
      return type === 'PJ' ? 'Pessoa Jurídica' : 'Pessoa Física';
    }
    return item.role_type || '';
  }

  getRowKey(item: any): string {
    return String(
      item?.register_uuid ?? (item?.register as any)?.id ?? item?.id ?? '',
    );
  }

  toggleRow(item: any) {
    const key = this.getRowKey(item);
    if (this.expandedRows.has(key)) {
      this.expandedRows.delete(key);
    } else {
      this.expandedRows.add(key);
    }
  }

  isRowExpanded(item: any): boolean {
    return this.expandedRows.has(this.getRowKey(item));
  }

  private getRegisterRolesForBadges(item: any): any[] {
    if (!item) return [];
    if (Array.isArray(item?.papers) && item.papers.length > 0) {
      return item.papers
        .map((paper: any) => paper?.role)
        .filter((role: any) => role && (role.applicable_display || role.name));
    }
    return [];
  }

  /** Badges da coluna Papel: somente `papers[].role` (Cotista FI quando aplicável). */
  getRolesForBadges(item: any): any[] {
    const rolesFromPapers = this.getRegisterRolesForBadges(item);
    if (rolesFromPapers.length === 0) {
      return [];
    }

    let rolesToDisplay = rolesFromPapers.filter(
      (role: any) => role && (role.applicable_display || role.name),
    );
    if (rolesToDisplay.length > 1) {
      rolesToDisplay = rolesToDisplay.filter(
        (role: any) => role.applicable !== 'representative',
      );
    }
    if (rolesToDisplay.length === 0) {
      rolesToDisplay = rolesFromPapers;
    }
    return rolesToDisplay.map((role: any) => {
      if (Utils.isPjFundRole(role)) {
        return {
          ...role,
          applicable_display: Utils.getRoleApplicableDisplayLabel(role),
        };
      }
      return role;
    });
  }

  getEstadoAtivoInativo(item: any): string {
    const papers = item?.papers ?? (item?.register as any)?.papers;
    if (
      Array.isArray(papers) &&
      papers.some((p: any) => p?.active === null)
    ) {
      return 'Em análise';
    }
    if (item?.active === null || (item?.register as any)?.active === null) {
      return 'Em análise';
    }
    if (typeof item?.active === 'boolean') {
      return item.active ? 'Ativo' : 'Inativo';
    }
    const state = (item?.register as any)?.state ?? item?.state;
    const s = (state || '').toString().toLowerCase();
    return s === 'active' || s === 'ativo' ? 'Ativo' : 'Inativo';
  }

  getEstadoBadgeClass(item: any): string {
    const estado = this.getEstadoAtivoInativo(item);
    if (estado === 'Em análise') {
      return 'status-badge status-badge-analysis';
    }
    if (estado === 'Ativo') {
      return 'status-badge status-badge-homologated';
    }
    // Mesmo padrão de Meus Cadastros: Inativo = vermelhinho (rejected)
    return 'status-badge status-badge-rejected';
  }

  getCreatedDate(item: any): string {
    const d = item?.created_date || item?.created_at;
    if (!d) return '—';
    const date = new Date(d);
    return isNaN(date.getTime()) ? '—' : date.toLocaleDateString('pt-BR');
  }

  getCreatedTime(item: any): string {
    const d = item?.created_date || item?.created_at;
    if (!d) return '';
    const date = new Date(d);
    return isNaN(date.getTime())
      ? ''
      : date.toLocaleTimeString('pt-BR', {
          hour: '2-digit',
          minute: '2-digit',
        });
  }

  getDocumentOnly(item: any): string {
    const doc =
      item?.document_number ??
      (item?.register as any)?.document_number ??
      (item?.register as any)?.person?.document ??
      (item?.register as any)?.company?.cnpj;
    if (!doc) return '';
    const str = String(doc).replace(/\D/g, '');
    if (str.length === 11)
      return this.maskPipe.transform(str, '000.000.000-00') || str;
    if (str.length === 14)
      return Utils.formatDocumentForDisplay(str) || str;
    return str;
  }

  /**
   * Linhas expandidas: somente `papers`, enriquecidos com dados do cadastro na lista.
   */
  getRoleControlsList(item: any): any[] {
    const regId = String(
      item?.register?.id ?? item?.register_id ?? item?.id ?? '',
    );
    if (!regId) {
      return this.buildRoleControlsList(item);
    }
    let list = this.roleControlsListCache.get(regId);
    if (!list) {
      list = this.buildRoleControlsList(item);
      this.roleControlsListCache.set(regId, list);
    }
    return list;
  }

  private buildRoleControlsList(item: any): any[] {
    const reg = item;
    const papers = Array.isArray(reg?.papers) ? reg.papers : [];
    if (papers.length === 0) {
      return [];
    }

    const profileValidity =
      reg?.investor_profile?.expire_register ??
      reg?.registration_expiration_date ??
      reg?.investor_profile?.validity ??
      null;
    const registerInvestorProfile =
      reg?.investor_profile?.profile_display ??
      reg?.investor_profile?.profile ??
      null;

    return papers.map((paper: any) => ({
      ...paper,
      state:
        paper?.active === true
          ? 'active'
          : paper?.active === false
            ? 'inactive'
            : paper?.active === null
              ? 'pending'
              : 'inactive',
      created_at:
        paper?.created_at ?? reg?.created_date ?? reg?.created_at ?? null,
      profile_validity: paper?.profile_validity ?? profileValidity,
      register_investor_profile: registerInvestorProfile,
      register_investor_profile_not_declared:
        reg?.investor_profile?.not_declared === true,
      investor_not_declared: reg?.investor_profile?.not_declared === true,
      current_stage_title: reg?.current_stage_title,
      current_stage_description: reg?.current_stage_description,
    }));
  }

  trackByUserItem(_index: number, item: any): string {
    return String(
      item?.register?.id ?? item?.register_id ?? item?.id ?? _index,
    );
  }

  trackByRoleControl(_index: number, rc: any): string {
    if (rc?.id != null && rc.id !== '') {
      return String(rc.id);
    }
    return `rc-${_index}`;
  }

  getRoleControlPapelName(rc: any): string {
    const role = rc?.role ?? {};
    return Utils.getRoleApplicableDisplayLabel(
      role,
      role?.name ?? rc?.role_name ?? '—',
    );
  }

  /** Se o role_control é de Representante (não mostra botão ativar/inativar). */
  isRepresentativeRoleControl(rc: any): boolean {
    if (!rc) return false;
    const role = rc.role || {};
    const applicable = (role.applicable || '').toString().toLowerCase();
    const slug = (role.slug || '').toString().toLowerCase();
    const name = (role.name || rc.role_name || '').toString().toLowerCase();
    return (
      applicable === 'representative' ||
      slug.includes('representative') ||
      name.includes('representante')
    );
  }

  private mapRoleControlStatus(raw?: string): string {
    const normalized = (raw || '').toString().trim().toLowerCase();
    if (/editing|created|em edição|em edicao/.test(normalized)) return 'Em edição';
    if (/pending|in approval|em aprovação|em aprovacao/.test(normalized)) {
      return 'Em aprovação';
    }
    if (/approved|homologated|homologado|aprovado/.test(normalized)) {
      return 'Homologado';
    }
    if (/rejected|rejeitado/.test(normalized)) return 'Rejeitado';
    if (/returned|retornado/.test(normalized)) return 'Retornado';
    return raw ? String(raw) : '-';
  }

  getRoleControlStatusDisplay(rc: any): string {
    const raw = rc?.status_display ?? rc?.status;
    return raw ? this.mapRoleControlStatus(String(raw)) : '-';
  }

  /**
   * Coluna Etapa: exibe título/descrição do estágio só quando o papel está em aprovação
   * (evita "Aguardando aprovação" com status já homologado).
   */
  isRoleControlEtapaVisible(rc: any): boolean {
    const label = this.getRoleControlStatusDisplay(rc).toLowerCase();
    return (
      label.includes('em aprovação') ||
      label.includes('em aprovacao')
    );
  }

  getRoleControlStatusClass(rc: any): string {
    const status = this.getRoleControlStatusDisplay(rc).toLowerCase();
    if (/homologado/.test(status)) return 'status-badge status-badge-homologated';
    if (/rejeitado/.test(status)) return 'status-badge status-badge-rejected';
    if (/retornado|returned/.test(status))
      return 'status-badge status-badge-rejected';
    if (/em aprovação/.test(status)) return 'status-badge status-badge-approval';
    return 'status-badge status-badge-editing';
  }

  getRoleControlProfile(rc: any): string {
    const role = rc?.role ?? {};
    const applicable = (role?.applicable || '').toString().toLowerCase();
    if (applicable === 'shareholder') {
      if (
        rc?.register_investor_profile_not_declared === true ||
        rc?.investor_not_declared === true
      ) {
        return 'Não declarado';
      }
      const shareholderProfile = rc?.register_investor_profile;
      return shareholderProfile ? String(shareholderProfile).trim() : '-';
    }
    const value = rc?.investor_profile ?? rc?.profile ?? '';
    return (value && String(value).trim()) ? String(value).trim() : '-';
  }

  getRoleControlProfileBadgeStyle(rc: any): { [key: string]: string } {
    const label = this.getRoleControlProfile(rc);
    const normalized = (label || '').toLowerCase().trim();
    let config: { badgeBackgroundColor: string; badgeTextColor: string } | null =
      null;
    if (/conservador/.test(normalized)) config = this.getInvestorProfileConfig(1);
    else if (/moderado/.test(normalized))
      config = this.getInvestorProfileConfig(2);
    else if (/agressivo/.test(normalized))
      config = this.getInvestorProfileConfig(3);
    else config = this.getNotDeclaredConfig();
    if (!config) return {};
    return {
      'background-color': config.badgeBackgroundColor,
      color: config.badgeTextColor,
    };
  }

  private formatPaperDateTime(raw: string): string {
    const date = new Date(raw);
    if (Number.isNaN(date.getTime())) return '-';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} às ${hours}:${minutes}`;
  }

  private formatPaperDateOnly(raw: string): string {
    const date = new Date(raw);
    if (Number.isNaN(date.getTime())) return '-';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  getRoleControlCreatedAt(rc: any): string {
    const raw = rc?.created_at;
    if (!raw) return '-';
    if (typeof raw === 'string' && raw.includes('/') && raw.length <= 10) {
      return raw;
    }
    return this.formatPaperDateTime(String(raw));
  }

  getRoleControlValidity(rc: any): string {
    const raw = rc?.profile_validity;
    if (!raw) return '-';
    if (typeof raw === 'string' && raw.includes('/') && raw.length <= 10) {
      return raw;
    }
    return this.formatPaperDateOnly(String(raw));
  }

  getRoleControlInactivationAt(rc: any): string {
    if (this.getRoleControlEstado(rc) !== 'Inativo') return '-';
    const raw = rc?.last_inactivation?.at;
    if (!raw) return '-';
    return this.formatPaperDateTime(String(raw));
  }

  getRoleControlInactivationDate(rc: any): string {
    const value = this.getRoleControlInactivationAt(rc);
    if (!value || value === '-') return '-';
    const [datePart] = value.split(' às ');
    return datePart || '-';
  }

  getRoleControlInactivationTime(rc: any): string {
    const value = this.getRoleControlInactivationAt(rc);
    if (!value || value === '-') return '';
    const [, timePart] = value.split(' às ');
    return timePart || '';
  }

  getRoleControlEstado(rc: any): string {
    if (rc && rc.active === null) {
      return 'Em análise';
    }
    if (typeof rc?.active === 'boolean') {
      return rc.active ? 'Ativo' : 'Inativo';
    }
    const state = (rc?.state ?? rc?.estado ?? '').toString().trim().toLowerCase();
    if (!state) return '-';
    if (
      state === 'pending' ||
      state === 'em_analise' ||
      state === 'em análise' ||
      state === 'analysis'
    ) {
      return 'Em análise';
    }
    return state === 'active' || state === 'ativo' ? 'Ativo' : 'Inativo';
  }

  getRoleControlEstadoClass(rc: any): string {
    const estado = this.getRoleControlEstado(rc);
    if (estado === 'Em análise') {
      return 'status-badge status-badge-analysis';
    }
    return estado === 'Ativo'
      ? 'status-badge status-badge-homologated'
      : 'status-badge status-badge-rejected';
  }

  isRolePaperEmAnalise(rc: any): boolean {
    return this.getRoleControlEstado(rc) === 'Em análise';
  }

  private isRoleInApprovalOrEditing(rc: any): boolean {
    const raw = (rc?.status_display ?? rc?.status ?? '')
      .toString()
      .trim()
      .toLowerCase();
    return /em aprovação|em aprovacao|pending|in approval|em_aprovacao/.test(raw) ||
      /em edição|em edicao|editing|created|em_edicao/.test(raw);
  }

  private getBlockingRoleForActivation(item: any, targetPaperId: string): any | null {
    const list = this.getRoleControlsList(item).filter(
      (rc: any) => !this.isRepresentativeRoleControl(rc),
    );
    return (
      list.find((rc: any) => {
        const id = rc?.id != null ? String(rc.id).trim() : '';
        return id !== targetPaperId && this.isRoleInApprovalOrEditing(rc);
      }) || null
    );
  }

  private getActivationBlockMessage(item: any, targetPaperId: string): string | null {
    const blocking = this.getBlockingRoleForActivation(item, targetPaperId);
    if (blocking) {
      return `Não é possível ativar este papel enquanto ${this.getRoleControlPapelName(blocking)} estiver ${this.getRoleControlStatusDisplay(blocking).toLowerCase()}.`;
    }

    return null;
  }

  isRoleActive(_item: any, rc: any): boolean {
    if (rc && rc.active === null) return false;
    if (typeof rc?.active === 'boolean') return rc.active;
    return (rc?.state ?? '').toString().toLowerCase() === 'active';
  }

  getPaperActionTooltip(item: any, rc: any): string {
    if (rc && this.isRepresentativeRoleControl(rc)) return '';
    return this.isRoleActive(item, rc) ? 'Inativar papel' : 'Ativar papel';
  }

  getPaperActionTitle(item: any | null, rc: any): string {
    if (rc && this.isRepresentativeRoleControl(rc)) return '';
    const active =
      item && rc != null ? this.isRoleActive(item, rc) : false;
    return active ? 'Inativar Papel' : 'Ativar Papel';
  }

  getPaperActionMessage(item: any | null, rc: any): string {
    if (rc && this.isRepresentativeRoleControl(rc)) return '';
    const active =
      item && rc != null ? this.isRoleActive(item, rc) : false;
    return active
      ? 'Tem certeza que deseja inativar o papel'
      : 'Tem certeza que deseja ativar o papel';
  }

  getRoleLabelForModal(rc: any): string {
    return this.getRoleControlPapelName(rc);
  }

  openPaperStatusModal(item: any, rc: any) {
    this.selectedPaperItem = item;
    this.selectedPaperRole = rc;
    this.paperStatusReasonForm.reset({ reason: null });
    this.showPaperStatusModal = true;
  }

  onPaperActionCellClick(event: Event, item: any, rc: any): void {
    if (this.isRepresentativeRoleControl(rc)) {
      return;
    }
    this.onPaperActionClick(event, item, rc);
  }

  onPaperActionClick(event: Event, item: any, rc: any) {
    event.preventDefault();
    event.stopPropagation();
    this.openPaperStatusModal(item, rc);
  }

  closePaperStatusModal() {
    this.showPaperStatusModal = false;
    this.selectedPaperItem = null;
    this.selectedPaperRole = null;
    this.paperStatusReasonForm.reset({ reason: null });
  }

  async confirmPaperStatusChange() {
    if (!this.selectedPaperItem || !this.selectedPaperRole) {
      return;
    }
    const rc = this.selectedPaperRole;
    const paperId = rc?.id != null ? String(rc.id).trim() : '';
    if (!paperId) {
      this.toast.show(
        'error',
        'Erro',
        'Dados insuficientes para alterar o status do papel.',
      );
      return;
    }

    const currentlyActive = this.isRoleActive(this.selectedPaperItem, rc);
    const isInactivating = currentlyActive;
    const active = !isInactivating;
    if (!currentlyActive) {
      const blockMessage = this.getActivationBlockMessage(
        this.selectedPaperItem,
        paperId,
      );
      if (blockMessage) {
        this.toast.show(
          'warning',
          'Atenção',
          blockMessage,
        );
        return;
      }
    }
    const reason = String(
      this.paperStatusReasonForm.get('reason')?.value ?? '',
    ).trim();
    if (!reason) {
      this.paperStatusReasonForm.get('reason')?.markAsTouched();
      this.toast.show('error', 'Erro', 'Informe o motivo para continuar.');
      return;
    }

    const regUuid = this.getRegisterUuid(this.selectedPaperItem) ?? '';

    this.paperStatusSubmitting = true;
    try {
      await this.api.patch({
        route: `api/v2/registration/registration-papers/${paperId}/`,
        token: true,
        body: { active, reason },
      });

      let requeueRan = false;
      if (!currentlyActive) {
        const shouldRequeue =
          this.registrationRequeue.shouldRequeueAfterRegisterReactivation(rc);
        if (shouldRequeue && regUuid) {
          try {
            await this.registrationRequeue.requeueActivatedRegisterToApproval(
              regUuid,
              paperId,
            );
            requeueRan = true;
          } catch {
            this.toast.show(
              'warning',
              'Atenção',
              'Papel reativado, mas não foi possível reenviar para aprovação automaticamente.',
            );
          }
        }
      }
      if (regUuid && !requeueRan) {
        try {
          await this.registrationRequeue.createRegistrationVersion(regUuid);
        } catch {
          /* best-effort */
        }
      }

      this.toast.show(
        'info',
        'Sucesso',
        isInactivating
          ? 'Papel inativado com sucesso.'
          : 'Papel ativado com sucesso.',
      );
      this.closePaperStatusModal();
      this.requestCounter++;
      const currentRequestId = this.requestCounter;
      await this.getUsers(this.page, currentRequestId);
    } catch (error) {
      console.error(error);
      this.toast.show(
        'error',
        'Erro',
        'Não foi possível alterar o status do papel. Tente novamente.',
      );
    } finally {
      this.paperStatusSubmitting = false;
      this.loading = false;
      this.loadingSummary = false;
    }
  }

  private getRegisterUuid(item: any | null): string {
    if (!item) return '';
    return String(
      item.register_uuid ?? (item.register as any)?.id ?? '',
    ).trim();
  }

  isRegisterActive(item: any | null): boolean {
    if (!item) return false;
    if (typeof item.active === 'boolean') return item.active;
    return this.getEstadoAtivoInativo(item) === 'Ativo';
  }

  /** Cadastro em análise: `active === null` no item/register ou em algum paper. */
  isRegisterEmAnalise(item: any | null): boolean {
    if (!item) return false;
    const papers = item.papers ?? (item.register as any)?.papers;
    if (
      Array.isArray(papers) &&
      papers.some((p: any) => p?.active === null)
    ) {
      return true;
    }
    if (item.active === null) return true;
    if ((item.register as any)?.active === null) return true;
    return false;
  }

  getRegisterActionTooltip(item: any): string {
    if (this.isRegisterEmAnalise(item)) {
      return 'Cadastro em análise — não é possível alterar ativação agora';
    }
    return this.isRegisterActive(item)
      ? 'Inativar cadastro'
      : 'Ativar cadastro';
  }

  getRegisterActionTitle(item: any | null): string {
    return this.isRegisterActive(item)
      ? 'Inativar Cadastro'
      : 'Ativar Cadastro';
  }

  getRegisterActionMessage(item: any | null): string {
    return this.isRegisterActive(item)
      ? 'Tem certeza que deseja inativar o cadastro'
      : 'Tem certeza que deseja ativar o cadastro';
  }

  getRegisterPapersRaw(item: any | null): any[] {
    return Array.isArray(item?.papers) ? item.papers : [];
  }

  getRegisterPapersForActivation(
    item: any | null,
  ): { id: string; label: string }[] {
    return this.getRegisterPapersRaw(item)
      .map((p: any) => ({
        id: p?.id != null ? String(p.id).trim() : '',
        label: this.getRoleControlPapelName(p),
      }))
      .filter((x) => x.id);
  }

  isRegisterActivationSinglePaper(): boolean {
    const item = this.selectedRegisterItem;
    if (!item || this.isRegisterActive(item) || this.isRegisterEmAnalise(item)) {
      return false;
    }
    return this.getRegisterPapersForActivation(item).length === 1;
  }

  getSingleRegisterActivationPaperLabel(): string {
    const item = this.selectedRegisterItem;
    if (!item) return '—';
    const papers = this.getRegisterPapersForActivation(item);
    return papers[0]?.label ?? '—';
  }

  isRegisterActivationMultiPaper(): boolean {
    const item = this.selectedRegisterItem;
    if (!item || this.isRegisterActive(item) || this.isRegisterEmAnalise(item)) {
      return false;
    }
    return this.getRegisterPapersForActivation(item).length > 1;
  }

  isRegisterActivationConfirmDisabled(): boolean {
    const reason = String(
      this.registerStatusReasonForm.get('reason')?.value ?? '',
    ).trim();
    if (!reason) return true;
    if (
      this.selectedRegisterItem &&
      this.isRegisterEmAnalise(this.selectedRegisterItem)
    ) {
      return true;
    }
    if (
      !this.selectedRegisterItem ||
      this.isRegisterActive(this.selectedRegisterItem)
    ) {
      return false;
    }
    // Com um único papel não há select: o id vem dos dados em confirmRegisterStatusChange.
    if (this.isRegisterActivationSinglePaper()) return false;
    const selected = String(
      this.registerActivatePapersForm.get('paperId')?.value ?? '',
    ).trim();
    return !selected;
  }

  private syncRegisterStatusConfirmDisabled(): void {
    this.registerStatusConfirmDisabled =
      this.isRegisterActivationConfirmDisabled();
    this.cdr.markForCheck();
  }

  onRegisterActionClick(event: Event, item: any) {
    event.preventDefault();
    event.stopPropagation();
    if (this.isRegisterEmAnalise(item)) {
      return;
    }
    this.openRegisterStatusModal(item);
  }

  openRegisterStatusModal(item: any) {
    if (this.isRegisterEmAnalise(item)) {
      return;
    }
    this.registerStatusModalFormSub?.unsubscribe();
    this.selectedRegisterItem = item;
    this.registerStatusReasonForm.reset({ reason: null });
    this.registerActivatePaperSelectItems =
      this.getRegisterPapersForActivation(item).map((p) => ({
        label: p.label,
        value: p.id,
      }));
    this.registerActivatePapersForm.patchValue({ paperId: null });
    this.showRegisterStatusModal = true;
    this.syncRegisterStatusConfirmDisabled();
    this.registerStatusModalFormSub = merge(
      this.registerStatusReasonForm.valueChanges,
      this.registerActivatePapersForm.valueChanges,
    ).subscribe(() => this.syncRegisterStatusConfirmDisabled());
  }

  closeRegisterStatusModal() {
    this.registerStatusModalFormSub?.unsubscribe();
    this.registerStatusModalFormSub = undefined;
    this.registerStatusConfirmDisabled = true;
    this.showRegisterStatusModal = false;
    this.selectedRegisterItem = null;
    this.registerActivatePaperSelectItems = [];
    this.registerActivatePapersForm.patchValue({ paperId: null });
    this.registerStatusReasonForm.reset({ reason: null });
  }

  async confirmRegisterStatusChange() {
    const item = this.selectedRegisterItem;
    const registerUuid = this.getRegisterUuid(item);
    if (!registerUuid) return;
    if (this.isRegisterEmAnalise(item)) {
      this.toast.show(
        'warning',
        'Atenção',
        'Cadastro em análise. Não é possível alterar a ativação agora.',
      );
      return;
    }

    const isInactivating = this.isRegisterActive(item);
    const active = !isInactivating;
    const reason = String(
      this.registerStatusReasonForm.get('reason')?.value ?? '',
    ).trim();
    if (!reason) {
      this.registerStatusReasonForm.get('reason')?.markAsTouched();
      this.toast.show('error', 'Erro', 'Informe o motivo para continuar.');
      return;
    }

    let paperIdsToActivate: string[] = [];
    let papersSnapshot: any[] = [];
    if (!isInactivating) {
      const papers = this.getRegisterPapersRaw(item);
      papersSnapshot = [...papers];
      if (papers.length === 0) {
        this.toast.show(
          'error',
          'Erro',
          'Nenhum papel encontrado para este cadastro.',
        );
        return;
      }
      if (papers.length === 1) {
        const id = papers[0]?.id != null ? String(papers[0].id).trim() : '';
        if (!id) {
          this.toast.show(
            'error',
            'Erro',
            'Dados insuficientes para ativar o cadastro.',
          );
          return;
        }
        paperIdsToActivate = [id];
      } else {
        const selected = String(
          this.registerActivatePapersForm.get('paperId')?.value ?? '',
        ).trim();
        if (!selected) return;
        paperIdsToActivate = [selected];
      }

      const blockMessage = this.getActivationBlockMessage(
        item,
        paperIdsToActivate[0],
      );
      if (blockMessage) {
        this.toast.show(
          'warning',
          'Atenção',
          blockMessage,
        );
        return;
      }
    }

    this.closeRegisterStatusModal();
    this.registerStatusSubmitting = true;

    try {
      if (isInactivating) {
        await this.api.patch({
          route: 'api/v3/registration/registers/',
          token: true,
          body: {
            register_uuid: registerUuid,
            active,
            reason,
          },
        });
        try {
          await this.registrationRequeue.createRegistrationVersion(registerUuid);
        } catch {
          /* best-effort */
        }
        this.toast.show('info', 'Sucesso', 'Cadastro inativado com sucesso.');
      } else {
        const paperResults = await Promise.all(
          paperIdsToActivate.map((paperId) =>
            this.api
              .patch({
                route: `api/v2/registration/registration-papers/${paperId}/`,
                token: true,
                body: { active: true, reason },
              })
              .then(() => ({ ok: true as const }))
              .catch(() => ({ ok: false as const })),
          ),
        );
        const paperFailures = paperResults.filter((r) => !r.ok).length;
        if (paperFailures > 0) {
          this.toast.show(
            'warning',
            'Atenção',
            'Não foi possível concluir todas as ações.',
          );
        } else {
          const targetPaperForRequeue =
            papersSnapshot.find(
              (p: any) =>
                String(p?.id != null ? p.id : '').trim() ===
                paperIdsToActivate[0],
            ) ?? null;
          const shouldRequeue =
            this.registrationRequeue.shouldRequeueAfterRegisterReactivation(
              targetPaperForRequeue,
            );
          let requeueRan = false;
          if (shouldRequeue && paperIdsToActivate[0]) {
            try {
              await this.registrationRequeue.requeueActivatedRegisterToApproval(
                registerUuid,
                paperIdsToActivate[0],
              );
              requeueRan = true;
            } catch {
              this.toast.show(
                'warning',
                'Atenção',
                'Cadastro reativado, mas não foi possível reenviar para aprovação automaticamente.',
              );
            }
          }
          if (!requeueRan) {
            try {
              await this.registrationRequeue.createRegistrationVersion(
                registerUuid,
              );
            } catch {
              /* best-effort */
            }
          }
          this.toast.show('info', 'Sucesso', 'Cadastro ativado com sucesso.');
        }
      }

      this.requestCounter++;
      const currentRequestId = this.requestCounter;
      this._page = 1;
      await this.getUsers(1, currentRequestId);
    } catch (error) {
      console.error(error);
      if (isInactivating) {
        this.toast.show(
          'error',
          'Erro',
          'Não foi possível alterar o status do cadastro. Tente novamente.',
        );
      }
    } finally {
      this.registerStatusSubmitting = false;
      this.loading = false;
      this.loadingSummary = false;
    }
  }

  redirectTo(path: string) {
    this.router.navigate([path]);
  }

  redirectToDetails(item: any) {
    if (this.permissionObj.canChange) {
      this.router.navigate([
        `app/admin/${
          item.role_applicable === 'provider'
            ? 'providers'
            : item.role_applicable + 's'
        }/${item.id}`,
      ]);
    }
  }

  setData() {
    this.signupService.fillFormEvent.subscribe(() => {
      this.form.patchValue({
        name: fakerbr.name.findName(),
        document: Utils.formatDocumentForDisplay(fakerbr.br.cnpj()),
        email: fakerbr.internet.email(),
        fund: fakerbr.random.number({ min: 1, max: 3 }),
      });

      if (this.selectedRole === 'provider') {
        this.form.patchValue({
          agent: [1],
        });
      }
    });
  }

  handleNewInvite(role: string) {
    this.selectedRole = role;
    this.newInvite = true;
    this.showOptions = false;

    if (role === 'provider') {
      this.form.controls.agent.setValidators([Validators.required]);
      this.form.controls.fund.setValidators([]);
    } else {
      this.form.controls.agent.setValidators([]);
      this.form.controls.fund.setValidators([Validators.required]);
    }

    this.form.controls.agent.updateValueAndValidity();
    this.form.controls.fund.updateValueAndValidity();
  }

  renderInviteTitle() {
    const role = this.formatName(this.selectedRole);
    return `Convidar ${role.toLowerCase()}`;
  }

  renderLink(item: any) {
    // Nova API v3 - usa register_uuid e mapeia role_name para slug
    if (item.register_uuid && item.role_name) {
      const roleSlug = this.getRoleSlugFromName(item.role_name);
      if (roleSlug) {
        return [`/app/details/${roleSlug}/`, item.register_uuid];
      }
    }

    // Fallback para estrutura antiga
    if (item.register) {
      return [
        `/app/details/${item.register.role.applicable}/`,
        item.register.id,
      ];
    }

    if (item.fund) {
      return [`/app/funds/approval/`, item.fund.id];
    }

    return '';
  }

  getRoleSlugFromName(roleName: string): string | null {
    const roleMap: { [key: string]: string } = {
      Cedente: 'assignor',
      Cotista: 'shareholder',
      'Prestador de serviço': 'provider',
      Provider: 'provider',
      Shareholder: 'shareholder',
      Assignor: 'assignor',
    };

    return roleMap[roleName] || null;
  }

  formatDocument(documentNumber: string): string {
    if (!documentNumber) return '';

    const onlyNumbers = Utils.normalizeDocumentForApi(documentNumber);

    if (onlyNumbers.length === 11) {
      // CPF
      return this.maskPipe.transform(onlyNumbers, '000.000.000-00');
    } else if (onlyNumbers.length === 14) {
      // CNPJ
      return Utils.formatDocumentForDisplay(onlyNumbers);
    }

    return documentNumber;
  }

  changePageData(page: number) {
    this.loadingTable = true;
    this.getUsers(page);
  }

  redirectToFirstMenuItem() {
    const menuItems = this.authService.navigationPermissions;

    if (this.router.url.includes('app')) {
      if (menuItems && menuItems.length > 0) {
        this.router.navigateByUrl(menuItems[0].route);
        return;
      }

      this.router.navigateByUrl('/app/dashboard');
    }
  }

  toggleExportOptions() {
    this.showExportOptions = !this.showExportOptions;
  }

  downloadTable(format: 'csv' | 'xlsx' | 'pdf') {
    this.toggleExportOptions();
    this.exporting = true;

    const filters = this.buildFilters();
    const headers = this.api.getHeaders(true, true);

    // Add export to filters (matching backend expectation)
    const params = new HttpParams({
      fromObject: { ...filters, export: format },
    });

    this.http
      .get(
        `${this.api.url}/api/approvals/v3/user_approval/my-area-dashboard/export/`,
        {
          headers: headers,
          params: params,
          responseType: 'blob',
          observe: 'response',
        },
      )
      .subscribe(
        (response: any) => {
          try {
            // Usa o blob recebido diretamente
            const blob = new Blob([response.body], {
              type:
                format === 'pdf'
                  ? 'application/pdf'
                  : format === 'csv'
                    ? 'text/csv'
                    : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            const url = window.URL.createObjectURL(blob);

            // Cria um link temporário no DOM
            const link = document.createElement('a');
            link.href = url;

            // Pega o nome do arquivo do header se disponível
            const contentDisposition = response.headers.get(
              'content-disposition',
            );
            let fileName = `relatorio_meu_departamento.${format}`;

            if (contentDisposition) {
              const fileNameMatch =
                contentDisposition.match(/filename="?(.+)"?/);
              if (fileNameMatch && fileNameMatch.length === 2)
                fileName = fileNameMatch[1];
            }

            link.setAttribute('download', fileName);

            // Simula o clique para iniciar o download
            document.body.appendChild(link);
            link.click();

            // Limpa
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            this.toast.show(
              'info',
              'Sucesso !',
              'Relatório gerado com sucesso!',
              null,
            );
          } catch (error) {
            console.error('Erro ao baixar exportação:', error);
            this.toast.show(
              'error',
              'Erro',
              'Falha ao baixar o arquivo.',
              null,
            );
          } finally {
            this.exporting = false;
          }
        },
        (error) => {
          console.error(error);
          this.toast.show('error', 'Erro', 'Erro ao baixar o arquivo.', null);
          this.exporting = false;
        },
      );
  }

  setPermissions() {
    // Adicionando permissão básica para permitir redirecionamento, ajustar conforme regras de negócio se necessário
    this.permissionObj.canChange = true;
  }

  canApprove(item: UserApprovalResponse) {
    let isPending = false;

    const register = this.authService.user.active_register
      ? this.authService.user.active_register.register
      : this.authService.user;

    if (item.current_department) {
      if (
        item.current_department.type === 'department' &&
        register.department &&
        item.current_department.department.id === register.department.id
      ) {
        isPending = true;
      }
      if (
        item.current_department.type === 'agent' &&
        register.agent.length > 0
      ) {
        isPending = register.agent.some(
          (_agent) => item.current_department.agent.id === _agent.id,
        );
      }
    }
    isPending = false;

    if (isPending) {
      return (
        !item.register.is_simplified &&
        item.completed &&
        !item.is_approved &&
        item.can_sign
      );
    } else {
      return false;
    }

    // const filteredData = pending
    //   .filter((assignor) => {
    //     if (assignor.register) {
    //       return !assignor.register.is_simplified;
    //     }
    //     return true;
    //   })
    //   .filter((assignor) => !(assignor.completed && !assignor.is_approved))
    //   .filter((assignor) => assignor.can_sign);
  }

  async getDepartments() {
    try {
      const res = await this.api.get({
        route: 'api/departments',
        token: true,
      });

      this.departmentOptions = res.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    }
  }

  async getCurrentStageDepartments() {
    try {
      const res = await this.api.get({
        route: 'department/',
        token: true,
      });

      this.currentStageDepartmentOptions = res.map((item: any) => ({
        label: item.name,
        value: item.id,
      }));
    } catch (error) {
      console.error(error);
      this.toast.show(
        'error',
        'Erro',
        'Ocorreu um erro ao carregar os departamentos.',
      );
    }
  }

  async refreshData() {
    this.loading = true;
    this.loadingSummary = true;
    this.loadingTable = true;
    try {
      await this.getUsers(this.page);
    } catch (error) {
      console.error(error);
      this.toast.show(
        'error',
        'Erro',
        'Ocorreu um erro ao atualizar os dados.',
      );
    } finally {
      this.loading = false;
      this.loadingSummary = false;
    }
  }

  generateFilterTags(formValues: any) {
    this.appliedFilters = [];
    const checkboxKeys = [
      'profileConservador',
      'profileModerado',
      'profileAgressivo',
      'profileNaoDeclarado',
      'profileIsento',
      'profileNaoAplicavel',
      'statusEmAprovacao',
      'statusHomologado',
      'estadoCadastroTodos',
      'estadoCadastroAtivo',
      'estadoCadastroInativo',
      'estadoTodos',
      'estadoAtivo',
      'estadoInativo',
    ];

    const fieldLabels: { [key: string]: string } = {
      name: 'Nome / Razão Social',
      document: 'CPF / CNPJ',
      role_filter: 'Papel',
      current_stage_department: 'Estágio Atual',
      expired: 'Validade do cadastro',
      investor_profile_number: 'Perfil de investidor',
      not_declared: 'Não declarado (perfil)',
      is_exempt: 'Isento',
      not_applicable: 'Não aplicável (perfil)',
      created_from: 'Data inicial',
      created_to: 'Data final',
      updated_from: 'Data inicial (atualização)',
      updated_to: 'Data final (atualização)',
      has_imported: 'Importado',
    };

    Object.entries(formValues).forEach(([key, value]: any) => {
      if (checkboxKeys.includes(key)) return;
      if (key === 'has_imported' && value !== true && value !== 'true') return;
      if (value !== null && value !== '' && value !== undefined) {
        let displayValue = value;
        if (Array.isArray(value) && value.length > 0)
          displayValue = value.join(', ');
        if (
          key === 'created_from' ||
          key === 'created_to' ||
          key === 'updated_from' ||
          key === 'updated_to'
        ) {
          if (value) {
            const str = String(value);
            const iso = str.includes('/')
              ? str.split('/').reverse().join('-')
              : str;
            const date = new Date(iso);
            if (!isNaN(date.getTime()))
              displayValue = date.toLocaleDateString('pt-BR');
          }
        }
        if (key === 'role_filter') {
          const option = this.roleFilterOptions.find(
            (opt) => opt.value === value,
          );
          displayValue = option ? option.label : value;
        }
        if (key === 'current_stage_department') {
          const option = this.currentStageDepartmentOptions.find(
            (opt) => opt.value === value,
          );
          displayValue = option ? option.label : value;
        }
        if (key === 'expired') {
          const normalizedValue =
            value === true || value === 'true'
              ? 'true'
              : value === false || value === 'false'
                ? 'false'
                : value;
          const expiredOption = this.expiredOptions.find(
            (opt) => opt.value === normalizedValue,
          );
          displayValue = expiredOption
            ? expiredOption.label
            : normalizedValue === 'true'
              ? 'Expirado'
              : normalizedValue === 'false'
                ? 'Não Expirado'
                : value;
        }
        if (key === 'investor_profile_number') {
          const profileOption = this.investorProfileOptions.find(
            (opt) => opt.value === value,
          );
          displayValue = profileOption ? profileOption.label : value;
        }
        if (key === 'not_declared') displayValue = 'Não declarado';
        if (key === 'has_imported')
          displayValue = value === true || value === 'true' ? 'Sim' : 'Não';
        if (fieldLabels[key]) {
          this.appliedFilters.push({
            label: `${fieldLabels[key]}: ${String(displayValue)}`,
            value: String(displayValue),
          });
        }
      }
    });

    const profileLabels: string[] = [];
    if (formValues.profileConservador) profileLabels.push('Conservador');
    if (formValues.profileModerado) profileLabels.push('Moderado');
    if (formValues.profileAgressivo) profileLabels.push('Agressivo');
    if (formValues.profileNaoDeclarado) profileLabels.push('Não declarado');
    if (formValues.profileIsento) profileLabels.push('Isento');
    if (formValues.profileNaoAplicavel) profileLabels.push('Não aplicável');
    if (profileLabels.length)
      this.appliedFilters.push({
        label: `Perfil de investimento: ${profileLabels.join(', ')}`,
        value: profileLabels.join(', '),
      });

    const statusLabels: string[] = [];
    if (formValues.statusEmAprovacao) statusLabels.push('Em aprovação');
    if (formValues.statusHomologado) statusLabels.push('Homologado');
    if (statusLabels.length)
      this.appliedFilters.push({
        label: `Status dos papéis: ${statusLabels.join(', ')}`,
        value: statusLabels.join(', '),
      });

    if (formValues.estadoCadastroAtivo)
      this.appliedFilters.push({
        label: 'Estado do cadastro: Ativo',
        value: 'Ativo',
      });
    else if (formValues.estadoCadastroInativo)
      this.appliedFilters.push({
        label: 'Estado do cadastro: Inativo',
        value: 'Inativo',
      });
    if (formValues.estadoAtivo)
      this.appliedFilters.push({
        label: 'Estado dos papéis: Ativo',
        value: 'Ativo',
      });
    else if (formValues.estadoInativo)
      this.appliedFilters.push({
        label: 'Estado dos papéis: Inativo',
        value: 'Inativo',
      });
  }

  getVersionLabel(item: any): string {
    if (item.approval_version_number != null) {
      return `${item.approval_version_number}ª versão`;
    }
    if (item.approval_version_label) {
      // Se vier algo como "Version 1", extrai o número
      const match = String(item.approval_version_label).match(/(\d+)/);
      if (match) {
        return `${match[1]}ª versão`;
      }
    }
    return '1ª versão';
  }

  // Método para obter o texto do badge (Novo ou Atualização)
  getVersionBadgeText(item: any): string {
    const versionNumber = item.approval_version_number || 1;
    if (versionNumber === 1) {
      return 'Novo';
    } else {
      return 'Atualização';
    }
  }

  // Método para obter o subtítulo da versão (ex: "1ª Versão", "2ª Versão")
  getVersionSubtitle(item: any): string {
    const versionNumber = item.approval_version_number || 1;
    return `${versionNumber}ª Versão`;
  }

  // Método para obter a classe CSS do badge de versão
  getVersionBadgeClass(item: any): string {
    const versionNumber = item.approval_version_number || 1;

    if (versionNumber === 1) {
      return 'version-badge-first';
    } else if (versionNumber >= 2 && versionNumber <= 5) {
      return 'version-badge-middle';
    } else {
      return 'version-badge-high';
    }
  }

  // Verificar se o registro é cotista (shareholder)
  isShareholder(item: any): boolean {
    return (
      item.role_name === 'Cotista' ||
      item.role_name === 'Cotista - Pessoa Física' ||
      item.role_name === 'Cotista - Pessoa Jurídica' ||
      item.role_name === 'Cotista - Fundo de Investimento'
    );
  }

  // Obter configuração do perfil de investidor
  getInvestorProfileConfig(profileNumber: number | null): any {
    const configs: { [key: number]: any } = {
      1: {
        type: 'Conservador',
        badgeTextColor: 'var(--badge-success-text)',
        badgeBackgroundColor: 'var(--badge-success-bg)',
      },
      2: {
        type: 'Moderado',
        badgeTextColor: 'var(--badge-info-text)',
        badgeBackgroundColor: 'var(--badge-info-bg)',
      },
      3: {
        type: 'Agressivo',
        badgeTextColor: 'var(--danger-dark)',
        badgeBackgroundColor: 'var(--danger-lighter)',
      },
    };
    return configs[profileNumber || 0] || null;
  }

  // Obter configuração para "Não declarado"
  getNotDeclaredConfig(): any {
    return {
      type: 'Não declarado',
      badgeTextColor: 'var(--input-black)',
      badgeBackgroundColor: 'var(--neutral-light)',
    };
  }

  getExemptInvestorProfileConfig(): any {
    return {
      type: 'Dispensa por norma',
      badgeTextColor: 'var(--neutral-alt)',
      badgeBackgroundColor: 'var(--table-header-bg)',
    };
  }

  // Obter dados de perfil de investidor/validade do registro
  getInvestorProfileData(item: any): any {
    if (!this.isShareholder(item)) {
      return null;
    }

    const investorProfile = item.investor_profile;

    // Se não tiver investor_profile, retornar null
    if (!investorProfile) {
      return null;
    }

    if (investorProfile.is_exempt === true) {
      return { is_exempt: true };
    }

    // Se not_declared é true ou profile é null, retornar dados para "Não declarado"
    if (
      investorProfile.not_declared === true ||
      investorProfile.profile === null
    ) {
      return {
        not_declared: true,
        profile: null,
      };
    }

    // Se tiver profile (1, 2 ou 3), usar valores da API ou calcular expiração
    // Profile 1 (Conservador): 2 anos
    // Profile 2 (Moderado): 1 ano
    // Profile 3 (Agressivo): 6 meses
    if (
      investorProfile.profile !== null &&
      investorProfile.profile !== undefined
    ) {
      let expireDate: Date | null = null;
      let daysUntilExpiration: number | null = null;
      let expired: boolean = false;

      // Prioridade 1: Usar valores da API se disponíveis
      if (
        investorProfile.days_to_expire !== null &&
        investorProfile.days_to_expire !== undefined
      ) {
        daysUntilExpiration = investorProfile.days_to_expire;
        expired = daysUntilExpiration < 0;

        // Se tiver expire_register, usar como expire_date
        if (investorProfile.expire_register) {
          expireDate = new Date(investorProfile.expire_register);
        }
      }
      // Prioridade 2: Calcular baseado em start_date + duração do perfil
      else if (investorProfile.start_date) {
        const startDate = new Date(investorProfile.start_date);
        expireDate = new Date(startDate);

        // Calcular duração baseada no perfil
        const profile = investorProfile.profile;
        if (profile === 1) {
          // Conservador: 2 anos
          expireDate.setFullYear(expireDate.getFullYear() + 2);
        } else if (profile === 2) {
          // Moderado: 1 ano
          expireDate.setFullYear(expireDate.getFullYear() + 1);
        } else if (profile === 3) {
          // Agressivo: 6 meses
          expireDate.setMonth(expireDate.getMonth() + 6);
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        expireDate.setHours(0, 0, 0, 0);

        const diffTime = expireDate.getTime() - today.getTime();
        daysUntilExpiration = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        expired = daysUntilExpiration < 0;
      }

      return {
        profile: investorProfile.profile,
        not_declared: false,
        expire_date: expireDate,
        days_until_expiration: daysUntilExpiration,
        expired: expired,
        start_date: investorProfile.start_date,
      };
    }

    return null;
  }

  // Obter estilo do badge de perfil de investidor
  getInvestorProfileBadgeStyle(item: any): any {
    const data = this.getInvestorProfileData(item);
    if (!data) {
      return {};
    }

    let config;
    if (data.is_exempt === true) {
      config = this.getExemptInvestorProfileConfig();
    } else if (data.not_declared === true || data.profile === null) {
      config = this.getNotDeclaredConfig();
    } else {
      config = this.getInvestorProfileConfig(data.profile);
    }

    if (!config) {
      return {};
    }

    return {
      'background-color': config.badgeBackgroundColor,
      color: config.badgeTextColor,
    };
  }

  // Obter texto do badge de perfil de investidor
  getInvestorProfileBadgeText(item: any): string {
    const data = this.getInvestorProfileData(item);
    if (!data) {
      return '';
    }

    let config;
    if (data.is_exempt === true) {
      config = this.getExemptInvestorProfileConfig();
    } else if (data.not_declared === true || data.profile === null) {
      config = this.getNotDeclaredConfig();
    } else {
      config = this.getInvestorProfileConfig(data.profile);
    }

    return config ? config.type : '';
  }

  // Obter texto de expiração
  getExpirationText(item: any): string {
    const data = this.getInvestorProfileData(item);
    if (!data) {
      return '';
    }

    if (data.is_exempt === true) {
      return '';
    }

    // Se for "Não declarado", não mostrar texto de expiração
    if (data.not_declared === true || data.profile === null) {
      return '';
    }

    const daysRemaining = data.days_until_expiration ?? 0;
    const expired = data.expired || daysRemaining < 0;

    if (expired) {
      return `Expirado há ${Math.abs(daysRemaining)} dias`;
    }

    return `Expira em ${daysRemaining} dias`;
  }

  get hasAnyFilterValue(): boolean {
    const values = this.filterForm.value;

    // Verificar campos normais
    const hasNormalFilters = Object.entries(values).some(
      ([key, value]: any) => {
        // Ignorar campos de data (são tratados separadamente)
        if (
          key === 'created_from' ||
          key === 'created_to' ||
          key === 'updated_from' ||
          key === 'updated_to'
        ) {
          return false;
        }
        if (value === null || value === '') {
          return false;
        }
        if (Array.isArray(value) && value.length === 0) {
          return false;
        }
        return true;
      },
    );

    // Verificar se há datas preenchidas (pelo menos um par completo)
    const hasCreatedDate =
      (values.created_from && values.created_to) ||
      (values.created_from && !values.created_to) ||
      (!values.created_from && values.created_to);
    const hasUpdatedDate =
      (values.updated_from && values.updated_to) ||
      (values.updated_from && !values.updated_to) ||
      (!values.updated_from && values.updated_to);

    return hasNormalFilters || hasCreatedDate || hasUpdatedDate;
  }

  get canApplyFilters(): boolean {
    // Verifica se há algum filtro preenchido
    if (!this.hasAnyFilterValue) {
      return false;
    }

    // Verifica se o documento é válido (quando preenchido)
    const documentControl = this.filterForm.controls.document;
    if (documentControl.value && documentControl.invalid) {
      return false;
    }

    return true;
  }

  /** `investor_profile_number` salvo como `"1,2,3"` ou legado array/número. */
  private parseInvestorProfileNumbersFromFilter(value: unknown): number[] {
    if (Array.isArray(value)) {
      return value
        .map((v) => Number(v))
        .filter((n) => !Number.isNaN(n) && (n === 1 || n === 2 || n === 3));
    }
    if (typeof value === 'string' && value.trim()) {
      return value
        .split(',')
        .map((s) => Number(s.trim()))
        .filter((n) => !Number.isNaN(n) && (n === 1 || n === 2 || n === 3));
    }
    if (typeof value === 'number' && (value === 1 || value === 2 || value === 3)) {
      return [value];
    }
    return [];
  }

  /** dd/mm/yyyy → yyyy-mm-dd para query da API. */
  private filterDateValueToApiFormat(value: unknown): string | undefined {
    const str = String(value ?? '').trim();
    if (!str) return undefined;
    if (str.includes('/')) {
      const parts = str.split('/');
      if (parts.length === 3) {
        const [d, m, y] = parts;
        return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
      }
      return str;
    }
    return str;
  }

  onEstadoCadastroChange(opcao: 'todos' | 'ativo' | 'inativo') {
    this.filterForm.patchValue(
      {
        estadoCadastroTodos: opcao === 'todos',
        estadoCadastroAtivo: opcao === 'ativo',
        estadoCadastroInativo: opcao === 'inativo',
      },
      { emitEvent: false },
    );
  }

  onEstadoPapeisChange(opcao: 'todos' | 'ativo' | 'inativo') {
    this.filterForm.patchValue(
      {
        estadoTodos: opcao === 'todos',
        estadoAtivo: opcao === 'ativo',
        estadoInativo: opcao === 'inativo',
      },
      { emitEvent: false },
    );
  }

}
